/* This example requires Tailwind CSS v2.0+ */
import * as React from "react";
import S from "./Cta.styled";
import { Link } from "gatsby";
import { IWPLink } from "@/src/types";

export interface Props {
  title: string;
  link: IWPLink;
}

const Cta: React.FC<Props> = ({ title, link }) => {
  return (
    <S.CTASection className="bg-metlab-200 relative overflow-hidden text-center md:text-left">
      <S.CircleBG />
      <div className="md:mx-auto md:max-w-7xl relative flex flex-col items-center justify-center py-10">
        <S.CTATitle>{title && title}</S.CTATitle>
        {link?.url && link?.title && (
          <Link to={link.url}>
            <a className="mt-2 flex items-center justify-center px-2 py-3 border border-transparent text-base font-medium rounded-full text-white bg-metlab-500 transition duration-200 ease-in-out hover:bg-green-600 md:py-3 md: md:px-6">
              {link.title}
            </a>
          </Link>
        )}
      </div>
    </S.CTASection>
  );
};

export default Cta;
